import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h2>Privacy Policy</h2>

      <h3>1. Introduction</h3>
      <p>
        Welcome to the Aadya Academy School Parent Application. Your privacy is critically
        important to us. This Privacy Policy explains how we collect, use, and safeguard your
        information when you use our application.
      </p>

      <h3>2. Information We Collect</h3>
      <ul>
        <li>
          <strong>Personal Information:</strong> We may collect personal details such as your name,
          email address, phone number, and payment information.
        </li>
        <li>
          <strong>Usage Data:</strong> Information on how you interact with our application,
          including app usage and session duration.
        </li>
        <li>
          <strong>Location Data:</strong> We may collect your location data if you grant permission.
        </li>
      </ul>

      <h3>3. How We Use Your Information</h3>
      <ul>
        <li>To provide and maintain our application services.</li>
        <li>To notify you about changes to our application.</li>
        <li>To provide customer support.</li>
        <li>To monitor usage and improve the app's performance.</li>
        <li>To process transactions and payments.</li>
      </ul>

      <h3>4. Data Sharing and Disclosure</h3>
      <ul>
        <li>
          <strong>With School Authorities:</strong> We may share data with school administrators for
          educational purposes.
        </li>
        <li>
          <strong>With Service Providers:</strong> We may share information with third-party service
          providers to facilitate payment processing and customer support.
        </li>
        <li>
          <strong>Legal Requirements:</strong> We may disclose your data if required by law.
        </li>
      </ul>

      <h3>5. Data Security</h3>
      <p>
        We implement appropriate security measures to protect your data. However, no method of
        transmission over the Internet is 100% secure.
      </p>

      <h3>6. Your Rights and Choices</h3>
      <ul>
        <li>Access, update, or delete your personal information.</li>
        <li>Opt-out of receiving promotional communications.</li>
        <li>Request information on how your data is being used.</li>
      </ul>

      <h3>7. Children’s Privacy</h3>
      <p>
        Our application is intended for educational purposes, and we do not knowingly collect
        personal information from children under the age of 13 without parental consent.
      </p>

      <h3>8. Changes to This Privacy Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. Please review this policy periodically
        for any changes.
      </p>

      <h3>9. Contact Information</h3>
      <p>
        <strong>Aadya Academy</strong>
        <br />
        Email: aadyaacademykannur@gmail.com
        <br />
        Address: No. 123/1, Vinayaka Layout, next to Goyal Orchid Greens, Hennur-Bagalur main road,
        Kannur, Bangalore - 560077
        <br />
        Phone: +91 890 473 2123
      </p>

      <h3>10. Acceptance of Terms</h3>
      <p>
        By using the Aadya Academy School Parent Application, you acknowledge and agree to the
        terms of this Privacy Policy.
      </p>

      <p>
        Additionally, ensure that your Store Listing includes a privacy policy to maintain
        transparency regarding sensitive user and device data. If your target audience includes
        children under the age of 13, comply with applicable regulations by reviewing the user data
        policy to avoid violations.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
